import React from "react"
import Header from "../components/header"
import "./layout.scss"
import { useStaticQuery, graphql, Link } from "gatsby"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query {
      dataJson {
          title
          location
          phone
          email
      }
    }
  `)
  return (
    <div className="flex flex-col h-screen">
      <Header />
      <main className="container mx-auto p-8 flex-auto bg-white">{children}</main>
      <footer className="border-t border-black bg-white pt-4 pb-12 lg:pb-4 mb-3 lg:mb-0 ">
        <div className="container mx-auto px-8 lg:relative">
          <p className="font-bold font-serif">© {new Date().getFullYear()}, {data.dataJson.title} Tous droits réservés</p>
          <p>
            <span className="font-bold">Adresse :</span> {data.dataJson.location}<br/>
            <span className="font-bold">Téléphone :</span> {data.dataJson.phone}<br/>
            <span className="font-bold">Courriel :</span> {data.dataJson.email}
          </p>
          <div className="lg:absolute lg:bottom-0 lg:right-8">
            <p className="text-right mt-2"><Link to="/mentions_legales/" className="underline text-right w-full">Mentions légales</Link></p>
            <p className="text-right"><a className="underline" href="https://www.instagram.com/rachel_person_/">Créations des bannières par Rachel Person</a></p>
            <p className="text-right"><a className="underline" href="https://mathisbarre.com">Design et développement par Mathis Barré</a></p>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Layout
